if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slides = [];
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.boundKeydown = this.onKeydown.bind(this);

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) {
          dialog.addEventListener('pointerup', (event) => event.stopPropagation());
        }

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-product-modal-previous]')) {
            this.changeSlide(-1);
          }

          if (event.target.closest('[data-product-modal-next]')) {
            this.changeSlide(1);
          }
        });

        const track = this.querySelector('[data-product-modal-track]');

        if (track) {
          track.addEventListener(
            'touchstart',
            (event) => {
              if (this.isInteractiveMedia(event.target) || event.touches.length !== 1) return;
              this.touchStartX = event.touches[0].clientX;
              this.touchStartY = event.touches[0].clientY;
            },
            { passive: true }
          );

          track.addEventListener(
            'touchend',
            (event) => {
              if (this.isInteractiveMedia(event.target) || event.changedTouches.length !== 1) return;

              const horizontalDistance = event.changedTouches[0].clientX - this.touchStartX;
              const verticalDistance = event.changedTouches[0].clientY - this.touchStartY;

              if (Math.abs(horizontalDistance) < 50 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;
              this.changeSlide(horizontalDistance > 0 ? -1 : 1);
            },
            { passive: true }
          );
        }
      }

      show(opener) {
        super.show(opener);
        this.collectSlides();
        this.showActiveMedia();
        document.addEventListener('keydown', this.boundKeydown);
      }

      hide() {
        document.removeEventListener('keydown', this.boundKeydown);
        this.pauseMedia();
        super.hide();
      }

      collectSlides() {
        const openedMediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const allSlides = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));

        this.slides = allSlides.filter(
          (slide) =>
            !slide.classList.contains('product__media-item--variant') ||
            slide.getAttribute('data-media-id') === openedMediaId
        );

        if (!this.slides.length) this.slides = allSlides;
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const activeIndex = this.slides.findIndex((slide) => slide.getAttribute('data-media-id') === openedMediaId);
        this.setActiveSlide(activeIndex >= 0 ? activeIndex : 0);
      }

      setActiveSlide(index) {
        if (!this.slides.length) return;

        this.pauseMedia();
        this.currentIndex = (index + this.slides.length) % this.slides.length;

        const allSlides = this.querySelectorAll('.product-media-modal__content > [data-media-id]');
        allSlides.forEach((slide) => {
          const isActive = slide === this.slides[this.currentIndex];
          slide.classList.toggle('active', isActive);
          slide.hidden = !isActive;
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        const activeSlide = this.slides[this.currentIndex];
        const activeTemplate = activeSlide.querySelector('template');

        if (activeSlide.nodeName === 'DEFERRED-MEDIA' && activeTemplate) {
          activeSlide.loadContent();
        }

        const current = this.querySelector('[data-product-modal-current]');
        const total = this.querySelector('[data-product-modal-total]');
        const controls = this.querySelectorAll(
          '[data-product-modal-previous], [data-product-modal-next], [data-product-modal-counter]'
        );

        if (current) current.textContent = this.currentIndex + 1;
        if (total) total.textContent = this.slides.length;
        controls.forEach((control) => {
          control.hidden = this.slides.length <= 1;
        });
      }

      changeSlide(direction) {
        if (this.slides.length <= 1) return;
        this.setActiveSlide(this.currentIndex + direction);
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.changeSlide(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.changeSlide(1);
        }
      }

      pauseMedia() {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      }

      isInteractiveMedia(target) {
        return Boolean(target.closest('video, iframe, model-viewer, button, a'));
      }
    }
  );
}